/**
 * Distintivo de racha viva.
 *
 * Se CALCULA al vuelo desde la racha actual que devuelve el backend. No hay tabla de
 * logros, ni historial, ni "conseguido el 12 de marzo": si el usuario pierde la racha, el
 * distintivo desaparece. Es un reflejo del estado de ahora, no una medalla.
 *
 * Los umbrales llegan del backend (`points_config`, R4) y son EXACTAMENTE los mismos que
 * activan los multiplicadores de puntos. Escribir 3 y 5 aquí sería inventar un segundo
 * sitio donde vive esa regla, y el día que Rafael los cambie el distintivo seguiría
 * anunciando un premio que ya no existe.
 */

/**
 * El mayor umbral alcanzado, o `null` si la racha no llega a ninguno.
 *
 * Solo el más alto, igual que R4 hace con los multiplicadores: con racha de 5 se enseña
 * el distintivo de 5, no el de 5 y el de 3.
 */
export function umbralAlcanzado(racha: number, umbrales: readonly number[]): number | null {
  let mejor: number | null = null;
  for (const umbral of umbrales) {
    if (umbral > 0 && racha >= umbral && (mejor === null || umbral > mejor)) {
      mejor = umbral;
    }
  }
  return mejor;
}

/** ¿Hay algo que celebrar? Azúcar sobre lo anterior, para que se lea en el JSX. */
export function tieneRachaViva(racha: number, umbrales: readonly number[]): boolean {
  return umbralAlcanzado(racha, umbrales) !== null;
}
